/// <reference types="cordova-plugin-device" />

export function getDevice(): Device {
  return device;
}
